<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/specialEvents?tab=cardCollection', true);
        if (localStorage.getItem("cardCollectionSeen") !== "true") {
            localStorage.setItem("cardCollectionSeen", "true");
        }
    });
</script>

<PackListing storeSection="cardCollection" title={$_('CardCollectionGenericEventTitle')}/>
